import React, { useEffect, useRef, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { loadImage, applyEmblemBlending, renderHearthstoneText, checkCondition, getNestedValue, getBase64Font } from '../utils/canvasEngine';
import { FaSpinner } from 'react-icons/fa';
import { useUser } from '../../../UserContext';

    // --- ALLY CARD MESH ---
    const ALLY_INDEX_BUFFER_BASE64 = `PgApAAIAPgA9ACkAAQA9AD4AAQAmAD0AKAApAD0AJQA9ACYAKAA9ADwAJQA8AD0AKAA8ADsAJQA7ADwAJQAgADsAKAA7ACcAOwAgACIAJwA7ADoAOwAiADoAJwA6ACQAIgA5ADoAJAA6ADkAJAA5ACMAIgAhADkAFwAjADkAOAA5ACEAFwA5ADgAOAAhAB0AHwAXADgAHAA4AB0AHwA4ADcAHAA3ADgAHwA3ADYAHAA2ADcAHAAYADYAHwA2AB4ANgAYABkAHgA2ADUANgAZADUAHgA1ABsAGQA0ADUAGwA1ADQAGQAEADQAGwA0ABoANAAEABQAGgA0ADMANAAUADMAGgAzABYAFAAyADMAFgAzADIAFgAyABUAFAATADIADgAVADIAMQAyABMADgAyADEAMQATABAAEgAOADEADwAxABAAEgAxADAADwAwADEAEgAwAC8ADwAvADAADwAFAC8AEgAvABEALwAFAAsAEQAvAC4ALwALAC4AEQAuAA0ACwAtAC4ADQAuAC0ADQAtAAwACwAKAC0ABgAMAC0ALAAtAAoABgAtACwALAAKAAgACQAGACwABwAsAAgACQAsACsABwArACwAAwAJACsAAwArACoAKgArAAcAKgAHAAAA`;
    const ALLY_VERTEX_DATA_BASE64 = `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`;
const ALLY_VERTEX_COUNT = 63;

    // --- SPELL CARD MESH ---
    const SPELL_INDEX_BUFFER_BASE64 = `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`;
    const SPELL_VERTEX_DATA_BASE64 = `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`;
const SPELL_VERTEX_COUNT = 234;

const DIAMOND_INDEX_BUFFER_BASE64 = `AAABAAIAAQADAAIAAgADAAQAAwABAAUAAQAGAAUAAwAFAAcAAwAIAAQACAADAAcABAAIAAkACAAHAAoACAALAAkACwAIAAoACQALAAwACwAKAA0ACwAOAAwADgALAA0ADAAOAA8ADgANABAADgARAA8AEQAOABAADwARABIAEQAQABMAEQAUABIAFAARABMAFAATABUAEgAUABYAFwAUABUAFAAXABYAFwAVABgAGQAXABgAFgAXABkAGgAWABkA`;
const DIAMOND_VERTEX_DATA_BASE64 = `WzlJv2rmET4jvIc+nzdVvSmhfz+pXF08APh5OSAPVb1pa3c/NUhcPcaHgL4AAIA/EtA/v2rmET7yvsY+oTdVvSmhfz+rXF08APR5OQAAAD9pa3c/NkhcPcSHgL4AAIA/phkYv6KTHD6Hblw+ghDVvFbofz/7M907AAAAPiAPVb27uHk/+P/bPIe1X74AAIA/SAARv6KTHD6Rba4+H9HVvCzofz/y+907AAAAPgAAAD/dtnk/EMfcPM3TX74AAIA/pnnMvqKTHD74wTY+9zhNvM36fz9oIbM6AACAPiAPVb2F/3w/YT1OPOXSG74AAIA/7OYJv6KTHD7fo+4+/qLgvLPlfz91N+k7AAAAPniohj99tHk/GvPnPP3QX74AAIA/y2Y2v2rmET7i4AI/WPtfvVWXfz+8iWg8APh5OXiohj/lYXc/PWdnPd6CgL4AAIA/e3e5vqKTHD6Lk90+Mm9VvGD6fz+8Tbo6AACAPniohj+s+3w/OH1WPJorHL4AAIA/kfjCvqKTHD5Depw+3SVLvOj6fz/TUbE6AACAPgAAAD8z/Hw/2CZMPNIrHL4AAIA/oYVPvgWLIT7RoR4+cOLLvJjrfz+4JOw6pgXAPiAPVb1b/n4/sGbMPLoTrr0AAIA/gXc8vgWLIT4tptI+/zTWvHnpfz8TLfo6/QXAPniohj8d+X4/YMLWPMU2r70AAIA/kf5FvgWLIT6K+5A+auPLvJjrfz+iHe465AjAPgAAAD86+34/+WnMPMs3r70AAIA/lUSju7V3Jj5bLBQ+AAAAgPr/fz/WBGw6AAAAPyAPVb0AAIA/AAAAAAAAAAAAAIA/lUSju7V3Jj516c0+AAAAgPn/fz9r+nc6AAAAP3iohj8AAIA/AAAAAAAAAAAAAIA/lUSju7V3Jj7R/4s+AAAAgPr/fz/WBGw6AAAAPwAAAD8AAIA/AAAAAAAAAAAAAIA/VlFFPgWLIT7RoR4+ceLLPJjrfz9NJ+w6Lf0fPyAPVb1b/n4/s2bMvLgTrj0AAIA/OUMyPgWLIT4tptI+BDXWPHnpfz8TLfo6Av0fP3iohj8d+X4/ZsLWvMc2rz0AAIA/SMo7PgWLIT6K+5A+aePLPJjrfz8+IO46jvsfPwAAAD86+34//GnMvMo3rz0AAIA/gl/HPqKTHD74wTY+9ThNPM36fz8nJLM6AABAPyAPVb2F/3w/bD1OvOTSGz4AAIA/VV20PqKTHD6Lk90+NW9VPGD6fz+/Tbo6AABAP3iohj+s+3w/O31WvJgrHD4AAIA/bN69PqKTHD5Depw+4CVLPOj6fz+RVLE6AABAPwAAAD8z/Hw/6CZMvNErHD4AAIA/2lkHP6KTHD7fo+4++qLgPLPlfz9wN+k7AABgP3iohj99tHk/FPPnvPzQXz4AAIA/lIwVP6KTHD6Hblw+hxDVPFbofz85NN07AABgPyAPVb27uHk//v/bvIa1Xz4AAIA/NnMOP6KTHD6Rba4+JdHVPCzofz81/N07AABgPwAAAD/dtnk/GsfcvMrTXz4AAIA/uNkzP2rmET7i4AI/VPtfPVWXfz9iiWg8YPB/P3iohj/lYXc/NGdnveGCgD4AAIA/AEM9P2rmET7yvsY+pTdVPSmhfz/CXF08YPB/PwAAAD9pa3c/O0hcvcSHgD4AAIA/SKxGP2rmET4jvIc+pDdVPSmhfz/DXF08YPB/PyAPVb1pa3c/OkhcvcaHgD4AAIA/`;
const DIAMOND_VERTEX_COUNT = 27;

const BELWE_FONT_FAMILY = 'Belwe';
const CYRILLIC_FONT_FAMILY = 'BNT85';
const CYRILLIC_FONT_URL = '/fonts/BNT85.ttf';
const CYRILLIC_PATTERN = /[\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F]/;

const containsCyrillic = (value) => CYRILLIC_PATTERN.test(String(value ?? ''));

const getCardFontFamily = (defaultFontFamily, value) => {
  const usesBelwe = String(defaultFontFamily || '').toLowerCase().includes('belwe');
  return usesBelwe && containsCyrillic(value) ? CYRILLIC_FONT_FAMILY : defaultFontFamily;
};

// Helper to decode Base64 data to an ArrayBuffer
function base64ToArrayBuffer(base64) {
  const cleaned = base64.replace(/\s/g, '');
  const binaryString = window.atob(cleaned);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// --- MESH PARSING & PERSPECTIVE PROJECTION UTILITIES ---

const parseMeshData = (type) => {
  const indexBufferBase64 = type === "ally" ? ALLY_INDEX_BUFFER_BASE64 : SPELL_INDEX_BUFFER_BASE64;
  const vertexDataBase64 = type === "ally" ? ALLY_VERTEX_DATA_BASE64 : SPELL_VERTEX_DATA_BASE64;
  const vertexCount = type === "ally" ? ALLY_VERTEX_COUNT : SPELL_VERTEX_COUNT;

  if (!indexBufferBase64 || !vertexDataBase64) return null;

  try {
    const vBuffer = base64ToArrayBuffer(vertexDataBase64);
    const iBuffer = base64ToArrayBuffer(indexBufferBase64);

    let stride = 32;
    const possibleStrides = [48, 40, 32, 44, 56, 64];
    for (const s of possibleStrides) {
      if (vBuffer.byteLength >= vertexCount * s) {
        stride = s;
        break;
      }
    }

    const vertices = [];
    const view = new DataView(vBuffer);

    for (let i = 0; i < vertexCount; i++) {
      const offset = i * stride;
      if (offset + 12 > view.byteLength) break;
      const x = view.getFloat32(offset + 0, true);
      const y = view.getFloat32(offset + 4, true);
      const z = view.getFloat32(offset + 8, true);

      let u = 0, v = 0;
      if (offset + 32 <= view.byteLength) {
        u = view.getFloat32(offset + 24, true);
        v = view.getFloat32(offset + 28, true);
      }

      // Replicate Three.js coordinate mapping: (x * -1, z * -1, y * 1)
      const wx = -x;
      const wy = -z;
      const wz = y;

      vertices.push({ wx, wy, wz, u, v });
    }

    const indices = new Uint16Array(iBuffer);
    return { vertices, indices };
  } catch (e) {
    console.warn("Could not parse mesh data:", e);
    return null;
  }
};

// Replicates Three.js' geometry.center()
const centerGeometry = (vertices) => {
  if (vertices.length === 0) return;
  let minX = Infinity, minY = Infinity, minZ = Infinity;
  let maxX = -Infinity, maxY = -Infinity, maxZ = -Infinity;

  vertices.forEach(v => {
    if (v.wx < minX) minX = v.wx;
    if (v.wy < minY) minY = v.wy;
    if (v.wz < minZ) minZ = v.wz;
    if (v.wx > maxX) maxX = v.wx;
    if (v.wy > maxY) maxY = v.wy;
    if (v.wz > maxZ) maxZ = v.wz;
  });

  const cx = (minX + maxX) / 2;
  const cy = (minY + maxY) / 2;
  const cz = (minZ + maxZ) / 2;

  vertices.forEach(v => {
    v.wx -= cx;
    v.wy -= cy;
    v.wz -= cz;
  });
};

// Replicates the perspective projection math of THREE.PerspectiveCamera
const projectVertex = (v, scale, cameraZ) => {
  // Apply geometry scale
  const sx = v.wx * scale;
  const sy = v.wy * scale;
  const sz = v.wz * scale;

  // View transform (Camera is at [0, 0, cameraZ] looking at [0, 0, 0])
  const xCam = sx;
  const yCam = sy;
  const zCam = cameraZ - sz;

  // Projection matrix variables
  const fovRad = 45 * Math.PI / 180;
  const fovFactor = Math.tan(fovRad / 2);
  const aspect = 1600 / 600;

  // Map to perspective viewport
  const xProj = xCam / (zCam * aspect * fovFactor);
  const yProj = yCam / (zCam * fovFactor);

  // Convert normalized projection coordinates to 1600x600 screen coordinates
  const screenX = (xProj + 1) * 800;
  const screenY = (1 - yProj) * 300;

  return { x: screenX, y: screenY };
};

// Renders an individual triangle mapped with affine coordinates onto the canvas
const drawTexturedTriangle = (ctx, img, x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, u2, v2, texWidth, texHeight) => {
  const tu0 = u0 * texWidth;
  const tv0 = (1 - v0) * texHeight;
  const tu1 = u1 * texWidth;
  const tv1 = (1 - v1) * texHeight;
  const tu2 = u2 * texWidth;
  const tv2 = (1 - v2) * texHeight;

  // Compute determinant for the linear system
  const det = tu0 * (tv1 - tv2) + tu1 * (tv2 - tv0) + tu2 * (tv0 - tv1);
  if (Math.abs(det) < 1e-6) return;

  const idet = 1 / det;
  const a = (x0 * (tv1 - tv2) + x1 * (tv2 - tv0) + x2 * (tv0 - tv1)) * idet;
  const c = (x0 * (tu2 - tu1) + x1 * (tu0 - tu2) + x2 * (tu1 - tu0)) * idet;
  const e = x0 - a * tu0 - c * tv0;

  const b = (y0 * (tv1 - tv2) + y1 * (tv2 - tv0) + y2 * (tv0 - tv1)) * idet;
  const d = (y0 * (tu2 - tu1) + y1 * (tu0 - tu2) + y2 * (tu1 - tu0)) * idet;
  const f = y0 - b * tu0 - d * tv0;

  ctx.save();
  ctx.beginPath();
  ctx.moveTo(x0, y0);
  ctx.lineTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.closePath();
  ctx.clip();

  ctx.transform(a, b, c, d, e, f);
  ctx.drawImage(img, 0, 0);
  ctx.restore();
};

// --- IMAGE COLORIZATION PIPELINE HELPER ---
const colorizeImage = (img, color, blendMode = 'multiply') => {
  // Prevent executing on zero-size images
  if (!img || img.width === 0 || img.height === 0) return img;

  const offCanvas = document.createElement('canvas');
  offCanvas.width = img.width;
  offCanvas.height = img.height;
  const offCtx = offCanvas.getContext('2d');

  // 1. Draw the original white/grayscale image
  offCtx.drawImage(img, 0, 0);

  // 2. Set the blend mode and apply the solid color fill
  offCtx.globalCompositeOperation = blendMode;
  offCtx.fillStyle = color;
  offCtx.fillRect(0, 0, offCanvas.width, offCanvas.height);

  // 3. Clip the colorized result back to the exact transparency mask of the original image
  offCtx.globalCompositeOperation = 'destination-in';
  offCtx.drawImage(img, 0, 0);

  // 4. Reset composite operation to default
  offCtx.globalCompositeOperation = 'source-over';

  return offCanvas;
};

const CardCanvas = forwardRef(({ cardParams, isArtLocked, zoomLevel, artUrl, onZoomConstraints, onArtTransform, onTextRendered, showToast, onZoomChange, zoomMin, zoomMax }, ref) => {
  const artLayerRef = useRef(null);
  const frameLayerRef = useRef(null);
  const textTempRef = useRef(null);
  const textLayerRef = useRef(null);
  const threeLayerRef = useRef(null);
  const svgRef = useRef(null);
  const dragOverlayRef = useRef(null);
  const containerRef = useRef(null);

  const [template, setTemplate] = useState(null);
  const [artImage, setArtImage] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isCyrillicFontReady, setIsCyrillicFontReady] = useState(false);
  const panState = useRef({ x: 0, y: 0, scale: 1, isDragging: false, startX: 0, startY: 0 });
  const isInitializing = useRef(false);

  const { settings } = useUser();

const hasText = (cardParams.Type === 'signature26' || cardParams.Type === 'weapon_signature')
  ? !!(cardParams.Text && cardParams.Text.trim() !== '')
  : false;

  const isTitleMeshActive = !!template?.titleMesh && settings?.cardTitleStyle !== "promotional";
  const needsCyrillicFontForSvg = (template?.texts || []).some((textObj) => {
    if (!checkCondition(textObj.condition, cardParams)) return false;
    if (isTitleMeshActive && textObj.bindTo === 'Title') return false;

    let value = getNestedValue(cardParams, textObj.bindTo);
    if (value === undefined || value === '') return false;
    if (textObj.valueTransform === 'split_0') value = String(value).split(/,\s*|\s+/)[0];
    if (textObj.valueTransform === 'split_1') value = String(value).split(/,\s*|\s+/)[1];
    return getCardFontFamily(textObj.fontFamily, value) === CYRILLIC_FONT_FAMILY;
  });
  const needsCyrillicFontForMesh = isTitleMeshActive && containsCyrillic(cardParams.Title);
  const needsCyrillicFont = needsCyrillicFontForSvg || needsCyrillicFontForMesh;

  // The @font-face rule is only a declaration; this is the first point at which
  // BNT85 is requested, and only cards containing Cyrillic reach it.
  useEffect(() => {
    if (!needsCyrillicFont || isCyrillicFontReady || !document.fonts?.load) return undefined;

    let isCancelled = false;
    document.fonts.load(`16px "${CYRILLIC_FONT_FAMILY}"`, '\u0416')
      .then(() => {
        if (!isCancelled) setIsCyrillicFontReady(true);
      })
      .catch((error) => {
        console.warn(`Failed to load ${CYRILLIC_FONT_FAMILY} for Cyrillic text`, error);
      });

    return () => { isCancelled = true; };
  }, [needsCyrillicFont, isCyrillicFontReady]);

  // Draws dynamic 2D text into the texture source canvas
  const drawTextToTexture = (texCanvas, text, calibration) => {
    const texCtx = texCanvas.getContext('2d');
    const { span, stretch, height } = calibration;
    const textureScale = 2;

    const targetHeight = height * textureScale;
    const targetWidth = 1024 * textureScale;

    texCanvas.height = targetHeight;
    texCanvas.width = targetWidth;

    texCtx.clearRect(0, 0, texCanvas.width, texCanvas.height);
    const centerX = texCanvas.width / 2;
    const centerY = texCanvas.height / 2;

    let fontSize = 101 * textureScale;
    const scaledSpan = span * textureScale;
    const fontFamily = getCardFontFamily(BELWE_FONT_FAMILY, text);

    texCtx.font = `normal ${fontSize}px '${fontFamily}', serif`;
    let measuredWidth = texCtx.measureText(text).width;

    while (measuredWidth > scaledSpan && fontSize > (20 * textureScale)) {
      fontSize -= (2 * textureScale);
      texCtx.font = `normal ${fontSize}px '${fontFamily}', serif`;
      measuredWidth = texCtx.measureText(text).width;
    }

    // Programmatically measure the visual height (cap height) of the font above the baseline
    // using "H" as a stable typographic reference
    const metrics = texCtx.measureText("H");
    const capHeight = metrics.actualBoundingBoxAscent;

    texCtx.save();
    texCtx.scale(1, stretch);

    texCtx.textAlign = "center";
    
    // Switch to 'alphabetic', which is standardized and rendered identically on all browsers
    texCtx.textBaseline = "alphabetic";

    // Mathematically offset the baseline so the midpoint of the capitals lands exactly on the center
    const textCenterY = (centerY / stretch) + (capHeight / 2);

    texCtx.lineWidth = Math.max(4 * textureScale, fontSize * 0.17);
    texCtx.strokeStyle = "rgb(1, 1, 1)";
    texCtx.lineJoin = "round";
    
    texCtx.strokeText(text, centerX, textCenterY);

    texCtx.shadowColor = "rgba(0, 0, 0, 0.9)";
    texCtx.shadowBlur = 10 * textureScale;
    texCtx.shadowOffsetY = (6 * textureScale) / stretch;

    texCtx.fillStyle = "#ffffff";
    texCtx.fillText(text, centerX, textCenterY);

    texCtx.restore();
  };

  // Warp Pipeline hook replacing WebGL renderer with CPU projection rendering onto standard 2D canvas
  const renderMeshText2D = (threeType, title, calibration) => {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = 1600;
    tempCanvas.height = 600;
    const tempCtx = tempCanvas.getContext('2d');

    // 1. Create text texture
    const texCanvas = document.createElement('canvas');
    drawTextToTexture(texCanvas, title, calibration);

    // 2. Parse and align mesh vertices
    const meshData = parseMeshData(threeType);
    if (!meshData) return null;

    const { vertices, indices } = meshData;
    centerGeometry(vertices);

    // 3. Project 3D geometry coordinates into 2D screenspace
    const projected = vertices.map(v => projectVertex(v, calibration.scale, calibration.cameraZ));

    // 4. Rasterize and transform textured triangles
    tempCtx.clearRect(0, 0, 1600, 600);
    const texWidth = texCanvas.width;
    const texHeight = texCanvas.height;

    for (let i = 0; i < indices.length; i += 3) {
      const idx0 = indices[i];
      const idx1 = indices[i + 1];
      const idx2 = indices[i + 2];

      const p0 = projected[idx0];
      const p1 = projected[idx1];
      const p2 = projected[idx2];

      const v0 = vertices[idx0];
      const v1 = vertices[idx1];
      const v2 = vertices[idx2];

      drawTexturedTriangle(
        tempCtx,
        texCanvas,
        p0.x, p0.y,
        p1.x, p1.y,
        p2.x, p2.y,
        v0.u, v0.v,
        v1.u, v1.v,
        v2.u, v2.v,
        texWidth,
        texHeight
      );
    }

    return tempCanvas;
  };

  // Dynamic banner render pipeline
  useEffect(() => {
    const canvas = threeLayerRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, 825, 1130);

    const titleMesh = template?.titleMesh;
    if (!titleMesh || !cardParams.Title || cardParams.Title.trim() === '' || settings?.cardTitleStyle === "promotional") {
      return;
    }

    const threeType = titleMesh.meshType;
    const calibration = titleMesh.calibration || {
      span: 1010,
      stretch: 1.6,
      height: 256,
      scale: 2.3,
      cameraZ: 2.3
    };

    let isCancelled = false;
    const titleFontFamily = getCardFontFamily(BELWE_FONT_FAMILY, cardParams.Title);
    const fontReady = document.fonts?.load
      ? document.fonts.load(`101px "${titleFontFamily}"`, cardParams.Title)
      : (document.fonts?.ready || Promise.resolve());

    fontReady.then(() => {
      if (isCancelled) return;
      const renderedCanvas = renderMeshText2D(threeType, cardParams.Title, calibration);
      if (!renderedCanvas) return;

      const placement = titleMesh.placement || { x: 12, y: 535, width: 800, height: 300 };
      
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.filter = 'blur(0.4px)';
      
      ctx.drawImage(
        renderedCanvas, 
        placement.x, 
        placement.y, 
        placement.width, 
        placement.height
      );
      
      ctx.restore();
    });

    return () => { isCancelled = true; };

  }, [cardParams.Title, template, settings?.cardTitleStyle, isCyrillicFontReady]);

  // --- HIGH QUALITY EXPORT FUNCTION ---
  const generateFinalCanvas = async () => {
    if (!template) return null;
    let cropTop = template.meta?.exportCrop?.default?.top || 0;
    let cropRight = template.meta?.exportCrop?.default?.right || 0;

    if (cardParams.Rarity === 'Legendary' || cardParams.Overwrite.Dragon === 'show') {
      cropTop = template.meta?.exportCrop?.legendary?.top || cropTop;
      cropRight = template.meta?.exportCrop?.legendary?.right || cropRight;
    }

    const width = 825 - cropRight;
    const height = 1130 - cropTop;

    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = width;
    exportCanvas.height = height;
    const ctx = exportCanvas.getContext('2d');
    
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(artLayerRef.current, 0, -cropTop);
    ctx.drawImage(frameLayerRef.current, 0, -cropTop);
    ctx.drawImage(threeLayerRef.current, 0, -cropTop);
    ctx.drawImage(textLayerRef.current, 0, -cropTop);

    const svgElement = svgRef.current;
    let svgString = new XMLSerializer().serializeToString(svgElement);
    
    if (!svgString.includes('xmlns="http://www.w3.org/2000/svg"')) {
      svgString = svgString.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
    }

    const belweFontBase64 = await getBase64Font('/fonts/Belwe_en.ttf', 'Belwe');
    const embeddedFonts = [belweFontBase64];
    if (needsCyrillicFontForSvg) {
      embeddedFonts.push(await getBase64Font(CYRILLIC_FONT_URL, CYRILLIC_FONT_FAMILY));
    }
    const styleString = `<style type="text/css"><![CDATA[ ${embeddedFonts.join('\n')} ]]></style>`;

    if (svgString.includes('<defs>')) {
      svgString = svgString.replace('<defs>', `<defs>${styleString}`);
    } else if (/<defs\s*\/?>/.test(svgString)) {
      svgString = svgString.replace(/<defs\s*\/?>/, `<defs>${styleString}</defs>`);
    } else {
      svgString = svgString.replace(/>/, `><defs>${styleString}</defs>`);
    }
    svgString = svgString.replace('viewBox="0 0 825 1130"', 'viewBox="0 0 825 1130" width="3300" height="4520"');

    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // const svgImg = new Image();
    // await new Promise((resolve) => { svgImg.onload = resolve; svgImg.src = url; });

    // const canvas4x = document.createElement('canvas');
    // canvas4x.width = 3300; canvas4x.height = 4520;
    // const ctx4x = canvas4x.getContext('2d');
    // ctx4x.drawImage(svgImg, 0, 0, 3300, 4520);

    // const canvas2x = document.createElement('canvas');
    // canvas2x.width = 1650; canvas2x.height = 2260;
    // const ctx2x = canvas2x.getContext('2d');
    // ctx2x.imageSmoothingEnabled = true;
    // ctx2x.imageSmoothingQuality = 'high';
    // ctx2x.drawImage(canvas4x, 0, 0, 1650, 2260);

    // ctx.drawImage(canvas2x, 0, -cropTop, 825, 1130);
    // URL.revokeObjectURL(url);

// Safari Fixed?

    const svgImg = new Image();

    try {
      await new Promise((resolve, reject) => {
        svgImg.onload = resolve;
        svgImg.onerror = () => reject(new Error('Failed to load the SVG used for card export.'));
        svgImg.src = url;
      });

      // In Safari, SVG onload can fire before an embedded data-URL font is
      // decoded and ready to paint. decode() covers browsers that expose the
      // readiness correctly; the short delay preserves the old Safari fix.
      if (typeof svgImg.decode === 'function') {
        try {
          await svgImg.decode();
        } catch (error) {
          console.warn('SVG export image decode did not complete cleanly.', error);
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 300));

      const canvas4x = document.createElement('canvas');
      canvas4x.width = 3300; canvas4x.height = 4520;
      const ctx4x = canvas4x.getContext('2d');
      ctx4x.drawImage(svgImg, 0, 0, 3300, 4520);

      const canvas2x = document.createElement('canvas');
      canvas2x.width = 1650; canvas2x.height = 2260;
      const ctx2x = canvas2x.getContext('2d');
      ctx2x.imageSmoothingEnabled = true;
      ctx2x.imageSmoothingQuality = 'high';
      ctx2x.drawImage(canvas4x, 0, 0, 1650, 2260);

      ctx.drawImage(canvas2x, 0, -cropTop, 825, 1130);
    } finally {
      URL.revokeObjectURL(url);
    }

    return exportCanvas;
  };

  useImperativeHandle(ref, () => ({
    exportCard: async () => {
      const exportCanvas = await generateFinalCanvas();
      if (!exportCanvas) return;
      const link = document.createElement('a');
      link.download = `${cardParams.Title.replace(/\s+/g, '-') || 'hearthcard'}.png`;
      link.href = exportCanvas.toDataURL('image/png');
      link.click();
    },
    copyToClipboard: async () => {
      const exportCanvas = await generateFinalCanvas();
      if (!exportCanvas) return;
      exportCanvas.toBlob(async (blob) => {
        try {
          await navigator.clipboard.write([new ClipboardItem({'image/png': blob})]);
          showToast('Card copied to clipboard!');
        } catch (e) {
          showToast('Failed to copy to clipboard. Ensure HTTPS connection.');
        }
      });
    },
    getCardImageBase64: async () => {
      const exportCanvas = await generateFinalCanvas();
      if (!exportCanvas) return null;
      return exportCanvas.toDataURL('image/png');
    }
  }));

  // Fetch JSON Template
  useEffect(() => {
    const abortController = new AbortController();

    const fetchTemplate = async () => {
      try {
        const res = await fetch(`/assets_template_new/${cardParams.Type}.json?v=3`, {
          signal: abortController.signal
        });
        const data = await res.json();
        setTemplate(data);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(`Failed to load template for ${cardParams.Type}:`, err);
        }
      }
    };
    
    fetchTemplate();

    return () => {
      abortController.abort();
    };
  }, [cardParams.Type]);

  // Utility: Get Bounding Box of the Art Area
  const getMaskBounds = useCallback(() => {
    const masks = template?.artMasks || [];
    if (masks.length === 0) return { x: 186, y: 106, w: 434, h: 490 }; 
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    masks.forEach(m => {
      if (m.x < minX) minX = m.x;
      if (m.y < minY) minY = m.y;
      if (m.x + m.width > maxX) maxX = m.x + m.width;
      if (m.y + m.height > maxY) maxY = m.y + m.height;
    });
    return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
  }, [template]);

  const clampPan = useCallback((targetX, targetY, scale, bounds, img) => {
    const scaledW = img.width * scale;
    const scaledH = img.height * scale;
    const minX = bounds.x + bounds.w - scaledW;
    const maxX = bounds.x;
    const minY = bounds.y + bounds.h - scaledH;
    const maxY = bounds.y;
    let outX = targetX, outY = targetY;
    if (scaledW <= bounds.w) outX = bounds.x + (bounds.w - scaledW)/2;
    else outX = Math.max(minX, Math.min(targetX, maxX));
    if (scaledH <= bounds.h) outY = bounds.y + (bounds.h - scaledH)/2;
    else outY = Math.max(minY, Math.min(targetY, maxY));
    return { x: outX, y: outY };
  }, []);

  useEffect(() => {
    if (!artUrl) {
      setArtImage(null);
      return;
    }
    loadImage(artUrl).then(img => setArtImage(img)).catch(console.warn);
  }, [artUrl]);

  // Extract variables for adjustment filters
  const artConfig = cardParams.Art || {};
  const brightness = artConfig.brightness ?? 100;
  const contrast = artConfig.contrast ?? 100;
  const saturation = artConfig.saturation ?? 100;
  const hue = artConfig.hue ?? 0;
  const flipX = artConfig.flipX ?? false;

  const drawArt = useCallback(() => {
    if (!artLayerRef.current || !template) return;
    const ctx = artLayerRef.current.getContext('2d');
    
    ctx.clearRect(0, 0, 825, 1130);

    if (!artImage) return;

    const masks = template.artMasks || [];
    ctx.save();
    
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    // Apply color/brightness filters
    ctx.filter = `brightness(${brightness}%) contrast(${contrast}%) saturate(${saturation}%) hue-rotate(${hue}deg)`;

    ctx.beginPath();
    masks.forEach(mask => {
      if (mask.type === "ellipse") ctx.ellipse(mask.x + mask.width/2, mask.y + mask.height/2, mask.width/2, mask.height/2, 0, 0, 2 * Math.PI);
      else if (mask.type === "rectangle") ctx.rect(mask.x, mask.y, mask.width, mask.height);
    });
    ctx.clip();
    const w = artImage.width * panState.current.scale;
    const h = artImage.height * panState.current.scale;

    // Apply flip horizontal transformation if active
    if (flipX) {
      ctx.translate(panState.current.x + w / 2, 0);
      ctx.scale(-1, 1);
      ctx.translate(-(panState.current.x + w / 2), 0);
    }


    ctx.drawImage(artImage, panState.current.x, panState.current.y, w, h);
    ctx.restore();
  }, [artImage, template, brightness, contrast, saturation, hue, flipX]);

  const latestParams = useRef(cardParams);
  useEffect(() => {
    latestParams.current = cardParams;
  }, [cardParams]);

  useEffect(() => {
    if (!artImage || !template) return;
    isInitializing.current = true;
    const bounds = getMaskBounds();
    const minScale = Math.max(bounds.w / artImage.width, bounds.h / artImage.height);
    
    const artConfig = latestParams.current.Art || {};
    const hasExplicitCoords = artConfig.x != null && artConfig.y != null && artConfig.scale != null;

    if (hasExplicitCoords) {
      panState.current.scale = artConfig.scale;
      panState.current.x = artConfig.x;
      panState.current.y = artConfig.y;
      
      if (onZoomConstraints) {
        onZoomConstraints({ min: minScale * 100, current: artConfig.scale * 100 });
      }
    } else {
      panState.current.scale = minScale;
      panState.current.x = bounds.x + (bounds.w - (artImage.width * minScale)) / 2;
      panState.current.y = bounds.y + (bounds.h - (artImage.height * minScale)) / 2;
      
      if (onZoomConstraints) {
        onZoomConstraints({ min: minScale * 100, current: minScale * 100 });
      }
    }

    drawArt();
    
    setTimeout(() => { isInitializing.current = false; }, 50);
  }, [artImage, template, getMaskBounds, drawArt, onZoomConstraints]);

  useEffect(() => {
    if (!artImage || !template || isInitializing.current) return;
    const newScale = zoomLevel / 100;
    const oldScale = panState.current.scale || newScale;
    if (newScale === oldScale) return;
    const bounds = getMaskBounds();
    const cx = bounds.x + bounds.w / 2;
    const cy = bounds.y + bounds.h / 2;
    let newX = cx - (cx - panState.current.x) * (newScale / oldScale);
    let newY = cy - (cy - panState.current.y) * (newScale / oldScale);
    const clamped = clampPan(newX, newY, newScale, bounds, artImage);
    panState.current.x = clamped.x;
    panState.current.y = clamped.y;
    panState.current.scale = newScale;
    drawArt();
  }, [zoomLevel, artImage, template, getMaskBounds, clampPan, drawArt]);

  const isPointInMask = useCallback((mouseX, mouseY) => {
    const masks = template?.artMasks || [];
    if (masks.length === 0) {
      return (mouseX >= 186 && mouseX <= 186 + 434 && mouseY >= 106 && mouseY <= 106 + 490);
    }

    for (const mask of masks) {
      if (mask.type === "ellipse") {
        const rx = mask.width / 2;
        const ry = mask.height / 2;
        const cx = mask.x + rx;
        const cy = mask.y + ry;
        if ((Math.pow(mouseX - cx, 2) / Math.pow(rx, 2)) + (Math.pow(mouseY - cy, 2) / Math.pow(ry, 2)) <= 1) {
          return true;
        }
      } else {
        if (mouseX >= mask.x && mouseX <= mask.x + mask.width && mouseY >= mask.y && mouseY <= mask.y + mask.height) {
          return true;
        }
      }
    }
    return false;
  }, [template]);

  const startDrag = useCallback((clientX, clientY) => {
    if (isArtLocked || !artImage) return;
    const rect = artLayerRef.current.getBoundingClientRect();
    const scaleX = 825 / rect.width;
    const scaleY = 1130 / rect.height;
    const mouseX = (clientX - rect.left) * scaleX;
    const mouseY = (clientY - rect.top) * scaleY;

    if (!isPointInMask(mouseX, mouseY)) return;

    panState.current.isDragging = true;
    panState.current.startX = mouseX;
    panState.current.startY = mouseY;
    
    if (dragOverlayRef.current) dragOverlayRef.current.style.cursor = 'grabbing';
  }, [isArtLocked, artImage, isPointInMask]);

  const moveDrag = useCallback((clientX, clientY) => {
    if (!artImage) return;
    const rect = artLayerRef.current.getBoundingClientRect();
    const scaleX = 825 / rect.width;
    const scaleY = 1130 / rect.height;
    const mouseX = (clientX - rect.left) * scaleX;
    const mouseY = (clientY - rect.top) * scaleY;

    if (!isArtLocked && dragOverlayRef.current && !panState.current.isDragging) {
      dragOverlayRef.current.style.cursor = isPointInMask(mouseX, mouseY) ? 'grab' : 'default';
    }

    if (!panState.current.isDragging) return;

    const dx = mouseX - panState.current.startX;
    const dy = mouseY - panState.current.startY;
    const bounds = getMaskBounds();

    const dampeningFactor = settings.artPanDampening ?? 0.6; 
    
    const targetX = panState.current.x + (dx * dampeningFactor);
    const targetY = panState.current.y + (dy * dampeningFactor);

    const clamped = clampPan(targetX, targetY, panState.current.scale, bounds, artImage);
    panState.current.x = clamped.x;
    panState.current.y = clamped.y;
    
    panState.current.startX = mouseX;
    panState.current.startY = mouseY;
    drawArt();

  }, [
    artImage, 
    isArtLocked, 
    isPointInMask, 
    getMaskBounds, 
    clampPan, 
    drawArt, 
    settings.artPanDampening
  ]);

  const endDrag = useCallback(() => { 
    if (!panState.current.isDragging) return;
    panState.current.isDragging = false; 

    if (dragOverlayRef.current) dragOverlayRef.current.style.cursor = 'grab';

    if (onArtTransform) {
      onArtTransform({ x: panState.current.x, y: panState.current.y, scale: panState.current.scale });
    }
  }, [onArtTransform]);

  useEffect(() => {
    if (dragOverlayRef.current) {
      dragOverlayRef.current.style.cursor = isArtLocked ? 'default' : 'auto';
    }
  }, [isArtLocked]);

  // --- FRAME RENDERING PIPELINE ---
  useEffect(() => {
    if (!template || !template.layers || !frameLayerRef.current) return;
    const visibleCtx = frameLayerRef.current.getContext('2d');
    let isCancelled = false;

    const buildPipeline = async () => {
      const currentParams = latestParams.current;
      const loadQueue = [];

      template.layers.forEach(layer => {
        if (!checkCondition(layer.condition, currentParams)) return;
        
        if (layer.type === "static") {
          loadQueue.push({ url: `assets/${layer.src}`, layer });
        } 
        else if (layer.type === "mapped") {
          const boundVal = getNestedValue(currentParams, layer.bindTo);
          const mappedSrc = layer.assets[boundVal];
          if (mappedSrc) loadQueue.push({ url: `assets/${mappedSrc}`, layer });
        } 
        else if (layer.type === "dynamic") {
          const boundVal = getNestedValue(currentParams, layer.bindTo);
          let dynPath = "";
          if (boundVal) {
            dynPath = (layer.prefix || "") + boundVal + (layer.suffix || "");
          } else if (layer.defaultSrc) {
            dynPath = layer.defaultSrc;
          }

          if (dynPath) {
            let finalX = layer.x, finalY = layer.y;
            if (layer.offsets) {
              for (const offset of layer.offsets) {
                if (checkCondition(offset.condition, currentParams)) {
                  finalX += offset.x || 0; 
                  finalY += offset.y || 0; 
                  break; 
                }
              }
            }
            if (layer.duplicateOnCondition && checkCondition(layer.duplicateOnCondition.condition, currentParams)) {
              loadQueue.push({ 
                url: `assets/${dynPath}`, 
                layer: { 
                  ...layer, 
                  x: layer.x + (layer.duplicateOnCondition.x || 0), 
                  y: layer.y + (layer.duplicateOnCondition.y || 0) 
                } 
              });
            }

            loadQueue.push({ url: `assets/${dynPath}`, layer: { ...layer, x: finalX, y: finalY } });
          }
        } 
        else if (layer.type === "classMapping") {
          const stdClasses = Object.keys(layer.assets);

          let mainSrc = "";
          if (stdClasses.includes(currentParams.Class)) {
            mainSrc = layer.assets[currentParams.Class];
          } else if (currentParams.Class && currentParams.Class !== "None") {
            mainSrc = `classes/${currentParams.Class}/${currentParams.Type}.png`;
          } else {
            mainSrc = layer.assets["Neutral"];
          }
          
          let dualSrc = null;
          if (currentParams.DualClass && currentParams.DualClass !== "None" && currentParams.DualClass !== "") {
            if (stdClasses.includes(currentParams.DualClass)) {
              dualSrc = layer.assets[currentParams.DualClass];
            } else {
              dualSrc = `classes/${currentParams.DualClass}/${currentParams.Type}.png`;
            }
          }

          if (dualSrc) {
            if (mainSrc) {
              loadQueue.push({ 
                url: `assets/${mainSrc}`, 
                layer, 
                sX: 0, sY: 0, sW: layer.width / 2 + 1, sH: layer.height, 
                dX: layer.x, dY: layer.y, dW: layer.width / 2 + 1, dH: layer.height 
              });
            }
            loadQueue.push({ 
              url: `assets/${dualSrc}`, 
              layer, 
              sX: layer.width / 2, sY: 0, sW: layer.width / 2, sH: layer.height, 
              dX: layer.x + layer.width / 2, dY: layer.y, dW: layer.width / 2, dH: layer.height 
            });
          } else {
            if (mainSrc) loadQueue.push({ url: `assets/${mainSrc}`, layer });
          }
        }
      });

      const loadedItems = await Promise.all(loadQueue.map(async (item) => {
        try { 
          let img = await loadImage(item.url); 
          
          if (item.layer && item.layer.colorize) {
            const colorizeConfig = item.layer.colorize;
            const boundVal = getNestedValue(currentParams, colorizeConfig.bindTo);
            
            // Extract mapped color or fallback to defaultColor
            const color = (colorizeConfig.colorMap && colorizeConfig.colorMap[boundVal]) 
                          || colorizeConfig.defaultColor;
            
            // Only apply colorization if a valid color value is present
            if (color && color !== "") {
              const blendMode = colorizeConfig.blendMode || 'multiply';
              img = colorizeImage(img, color, blendMode);
            }
          }
          
          return { ...item, img }; 
        } catch (e) { 
          return null; 
        }
      }));

      if (isCancelled) return; 

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = 825; 
      tempCanvas.height = 1130;
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx.imageSmoothingEnabled = true;
      tempCtx.imageSmoothingQuality = 'high';

      for (const item of loadedItems) {
        if (!item || !item.img) continue;
        if (item.sW) {
          tempCtx.drawImage(item.img, item.sX, item.sY, item.sW, item.sH, item.dX, item.dY, item.dW, item.dH);
        } else {
          tempCtx.drawImage(item.img, item.layer.x, item.layer.y, item.layer.width, item.layer.height);
        }
      }

      const showEmblem = currentParams.Overwrite.Emblem === 'show' || (currentParams.Rarity !== 'Free' && currentParams.Overwrite.Emblem !== 'hide');
      if (currentParams.Emblem && showEmblem && template.emblem) {
        try {
          const emblemImg = await loadImage(`assets/emblems/${currentParams.Emblem}.png`);
          
          if (!isCancelled) {
            const emblemConfig = { ...template.emblem };
            if (currentParams.Tribe && currentParams.Tribe.trim() !== '' && emblemConfig.tribeYOffset) {
              emblemConfig.y += emblemConfig.tribeYOffset;
            }
            applyEmblemBlending(tempCtx, emblemImg, emblemConfig);
          }
        } catch(e) { }
      }

      if (isCancelled) return;

      visibleCtx.clearRect(0, 0, 825, 1130);
      visibleCtx.drawImage(tempCanvas, 0, 0);
    };

    buildPipeline();
    return () => { isCancelled = true; };
    
  }, [
    template, 
    cardParams.Type, 
    cardParams.Class, 
    cardParams.CustomClass, 
    cardParams.DualClass, 
    cardParams.Rarity, 
    cardParams.Banner, 
    cardParams.RightBanner, 
    cardParams.Runes, 
    cardParams.Cost, 
    cardParams.Attack, 
    cardParams.Health, 
    cardParams.Tribe, 
    cardParams.Emblem, 
    cardParams.Overwrite.Emblem,
    cardParams.Overwrite.Dragon,
    cardParams.ChronumCost,
    hasText,
    settings?.cardTitleStyle,
    cardParams.Art?.disableDropShadow
  ]);

  // --- TEXT RENDERING PIPELINE ---
  useEffect(() => {
    if (!template || !template.descriptionBox || !textLayerRef.current || !textTempRef.current) return;
    const ctxTemp = textTempRef.current.getContext('2d');
    const ctxFinal = textLayerRef.current.getContext('2d');
    
    ctxTemp.imageSmoothingEnabled = true;
    ctxTemp.imageSmoothingQuality = 'high';
    ctxFinal.imageSmoothingEnabled = true;
    ctxFinal.imageSmoothingQuality = 'high';
    ctxTemp.fontKerning = 'none'; 
    ctxFinal.fontKerning = 'none'; 

    document.fonts.ready.then(() => {
       const result = renderHearthstoneText(
         ctxTemp,
         ctxFinal,
         cardParams.Text,
         { ...latestParams.current, customAutobold: settings?.customAutobold },
         template.descriptionBoxNew
       );
       if (onTextRendered && result) {
         onTextRendered(result.activeFontSize, result.defaultFontSize);
       }
    });

  }, [
    template, 
    cardParams.Text, 
    cardParams.Type, 
    cardParams.Tribe, 
    cardParams.Overwrite.FontSize,
    settings?.customAutobold
  ]);

  useEffect(() => {
    const overlay = dragOverlayRef.current;
    if (!overlay) return;

    const handleTouchStart = (e) => { 
      if (isArtLocked) return; 
      startDrag(e.touches[0].clientX, e.touches[0].clientY); 
    };

    const handleTouchMove = (e) => { 
      if (isArtLocked) return; 
      if (panState.current.isDragging) {
        e.preventDefault(); 
      }
      moveDrag(e.touches[0].clientX, e.touches[0].clientY); 
    };

    const handleTouchEnd = () => { endDrag(); };

    overlay.addEventListener('touchstart', handleTouchStart, { passive: false });
    overlay.addEventListener('touchmove', handleTouchMove, { passive: false });
    overlay.addEventListener('touchend', handleTouchEnd);
    overlay.addEventListener('touchcancel', handleTouchEnd);
    return () => {
      overlay.removeEventListener('touchstart', handleTouchStart);
      overlay.removeEventListener('touchmove', handleTouchMove);
      overlay.removeEventListener('touchend', handleTouchEnd);
      overlay.removeEventListener('touchcancel', handleTouchEnd);
    };
  }, [isArtLocked, startDrag, moveDrag, endDrag]);

  const renderSVGTexts = () => {
    if (!template || !template.texts) return null;

    const getShrunkTitle = (text, defaultSize, fontFamily, maxWidth = 600) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      let size = defaultSize;
      
      ctx.font = `normal 400 ${size}px ${fontFamily}`;
      
      while (ctx.measureText(text).width > maxWidth && size > 20) {
        size -= 1;
        ctx.font = `normal 400 ${size}px ${fontFamily}`;
      }
      return size;
    };

    const isThreeActive = !!template?.titleMesh && settings?.cardTitleStyle !== "promotional";

    return template.texts.map((textObj, idx) => {
      if (!checkCondition(textObj.condition, cardParams)) return null;

      let val = getNestedValue(cardParams, textObj.bindTo);
      if (val === undefined || val === '') return null;

      if (isThreeActive && textObj.bindTo === "Title") return null;

      if (textObj.valueTransform === "split_0") val = val.split(/,\s*|\s+/)[0];
      if (textObj.valueTransform === "split_1") val = val.split(/,\s*|\s+/)[1];
      if (!val) return null;

      const fontFamily = getCardFontFamily(textObj.fontFamily, val);

      if (textObj.renderType === "path") {
        const maxWidth = textObj.maxWidth || 600; 
        const finalFontSize = getShrunkTitle(val, textObj.fontSize, fontFamily, maxWidth);
        const dyShift = -(textObj.fontSize - finalFontSize) / 3;
        const finalStrokeWidth = textObj.strokeWidth;

        return (
          <g key={`path-text-${idx}`}>
            <defs><path id={`pathDef-${idx}`} d={textObj.pathD} /></defs>
            <text 
              dy={dyShift} 
              fontFamily={fontFamily} 
              fontSize={finalFontSize} 
              fill="white" 
              stroke={textObj.stroke} 
              strokeWidth={finalStrokeWidth} 
              strokeLinejoin="round" 
              textAnchor="middle"
            >
              <textPath href={`#pathDef-${idx}`} startOffset="50%">{val}</textPath>
            </text>
            <text 
              dy={dyShift} 
              fontFamily={fontFamily} 
              fontSize={finalFontSize} 
              fill={textObj.fill} 
              textAnchor="middle"
            >
              <textPath href={`#pathDef-${idx}`} startOffset="50%">{val}</textPath>
            </text>
          </g>
        );
      }
      
      if (textObj.renderType === "rect") {
        const xCenter = textObj.x + (textObj.width / 2);
        const yCenter = textObj.y + (textObj.height / 2) - 10;
        
        return (
          <g key={`rect-text-${idx}`}>
            <text x={xCenter} y={yCenter} fontFamily={fontFamily} fontSize={textObj.fontSize} fill="white" stroke={textObj.stroke} strokeWidth={textObj.strokeWidth} strokeLinejoin="round" textAnchor="middle">{val}</text>
            <text x={xCenter} y={yCenter} fontFamily={fontFamily} fontSize={textObj.fontSize} fill={textObj.fill} textAnchor="middle">{val}</text>
          </g>
        );
      }
      return null;
    });
  };

// Keydown handler for Arrow Keys
  const handleKeyDown = useCallback((e) => {
    if (!isFocused || isArtLocked || !artImage) return;

    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault(); // Prevents page scrolling

      const step = e.shiftKey ? 10 : 2;
      let targetX = panState.current.x;
      let targetY = panState.current.y;

      if (e.key === 'ArrowLeft') targetX -= step;
      if (e.key === 'ArrowRight') targetX += step;
      if (e.key === 'ArrowUp') targetY -= step;
      if (e.key === 'ArrowDown') targetY += step;

      const bounds = getMaskBounds();
      const clamped = clampPan(targetX, targetY, panState.current.scale, bounds, artImage);
      
      panState.current.x = clamped.x;
      panState.current.y = clamped.y;
      drawArt();

      if (onArtTransform) {
        onArtTransform({ x: clamped.x, y: clamped.y, scale: panState.current.scale });
      }
    }
  }, [isFocused, isArtLocked, artImage, getMaskBounds, clampPan, drawArt, onArtTransform]);

// Wheel listener to prevent native window scrolling (zooms on hover without click)
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      if (isArtLocked || !artImage) return;
      e.preventDefault();

      const delta = -e.deltaY;
      const step = e.shiftKey ? 5 : 1;
      const zoomChange = delta > 0 ? step : -step;

      if (onZoomChange && zoomMin !== undefined && zoomMax !== undefined) {
        const nextZoom = Math.max(zoomMin, Math.min(zoomMax, zoomLevel + zoomChange));
        onZoomChange(nextZoom);
        
        if (onArtTransform) {
          onArtTransform({ x: panState.current.x, y: panState.current.y, scale: nextZoom / 100 });
        }
      }
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, [isArtLocked, artImage, zoomLevel, zoomMin, zoomMax, onZoomChange, onArtTransform]);

  return (
    <div 
      ref={containerRef}
      className="canvas-container" 
      style={{ 
        position: 'relative', 
        width: '100%', 
        aspectRatio: '0.73',
        outline: 'none',
        borderRadius: '12px',
        transition: 'box-shadow 0.2s ease-in-out'
      }}
      tabIndex={0}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
     onKeyDown={handleKeyDown}
    >
      <div 
        ref={dragOverlayRef}
        style={{ 
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 45, 
          pointerEvents: isArtLocked ? 'none' : 'auto',
          touchAction: 'auto',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          WebkitUserDrag: 'none' 
        }}
        onDragStart={(e) => e.preventDefault()}
        
        onMouseDown={(e) => startDrag(e.clientX, e.clientY)}
        onMouseMove={(e) => moveDrag(e.clientX, e.clientY)}
        onMouseUp={endDrag}
        onMouseLeave={() => {
          endDrag();
          if (!isArtLocked && dragOverlayRef.current) dragOverlayRef.current.style.cursor = 'default';
        }}
      />
      <canvas ref={artLayerRef} width={825} height={1130} style={{ position: 'absolute', top: 0, left: 0, width: '100%' }} />
      <canvas ref={frameLayerRef} width={825} height={1130} style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 20 }} />
      <canvas ref={threeLayerRef} width={825} height={1130} style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 25 }} />
      <canvas ref={textTempRef} width={825} height={1130} style={{ display: 'none' }} />
      <canvas ref={textLayerRef} width={825} height={1130} style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 30 }} />

      <svg ref={svgRef} viewBox="0 0 825 1130" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 40, pointerEvents: 'none' }}>
        <defs></defs> 
        {renderSVGTexts()}
      </svg>
    </div>
  );
});

export default CardCanvas;
